import AdvertiserModel     from 'models/AdvertiserModel';
import AdvertiserShowModel from 'models/AdvertiserShowModel';
import ProviderShowModel   from 'models/ProviderShowModel';
import ProviderModel       from 'models/ProviderModel';

const isAnEmail = (text: string) => text.indexOf('@') >= 0;

export const linkWithLinkType = (link: string) => {
  let prefix = '';
  if (isAnEmail(link)) {
    prefix = 'mailto:';
  } else {
    prefix = 'https://';
  }

  if (link.indexOf(prefix) < 0) {
    return prefix + link;
  }
  return link;
};

export const getAdvertiserAndAdvertiserShowMixData = (advertiser: AdvertiserModel, advertiserShow: AdvertiserShowModel) => {
  const advertiserName = advertiser ? advertiser.get('name') : '';

  const wording = advertiserShow.get('wording') ? advertiserShow.get('wording') : advertiserName;

  const advertiserLink = advertiser ? advertiser.get('link') : '';

  const link = advertiserShow.get('link') ? advertiserShow.get('link') : advertiserLink;

  const linkFull = advertiserShow.get('link')
    ? linkWithLinkType(advertiserShow.get('link'))
    : linkWithLinkType(advertiserLink);

  return {
    link,
    linkFull,
    wording,
  };
};

export const getProviderAndProviderShowMixData = (provider: ProviderModel, providerShow: ProviderShowModel) => {
  const providerName = provider ? provider.get('name') : '';

  const name = providerShow.get('wording') ? providerShow.get('wording') : providerName;

  const providerEmail = provider ? provider.get('email') : '';

  const email = providerShow.get('email') ? providerShow.get('email') : providerEmail;

  const providerLink = provider.get('link') ? provider.get('link') : '';

  const link = providerShow.get('link') ? providerShow.get('link') : providerLink;

  const linkFull = providerShow.get('link')
    ? linkWithLinkType(providerShow.get('link'))
    : linkWithLinkType(providerLink);

  return {
    email,
    link,
    linkFull,
    name,
  };
};
